import { useQuery } from '@tanstack/react-query';
import { messageStatusService } from '../services/message-status.service';

export const useMessageReadUsers = (conversationId: string, messageId: string, enabled = true) => {
  return useQuery({
    queryKey: ['message-read-users', conversationId, messageId],
    queryFn: async () => {
      const response = await messageStatusService.getReadUsers(conversationId, messageId, 5); // Limit to 5 for menu display
      return response.data;
    },
    enabled: enabled && !!conversationId && !!messageId,
    staleTime: 1000 * 60 // 1 minute
  });
};
